<template>
    <div class="main-container">
        <my-header></my-header>
        <div class="container">
            <h1 style="text-align: center;font-size: 22px;">{{extWFlowForm.bidItemName}}</h1>
            <div style="text-align: right; margin-top:20px; margin-right: 10px;">
                <el-button type="default" size="mini" @click="saveToDraft()">保存</el-button>
                <el-button type="primary" size="mini" @click="submit()">提交</el-button>
            </div>
            <section class="small-container">
                <h3 class="iconfont iconxiala">商务谈判</h3>
                <el-row class="colorLine">
                    <el-col :span="10">
                        <div style="height: 1px;background: #91002c;"></div>
                    </el-col>
                    <el-col :span="14">
                        <div style="height: 1px;background: #003570;"></div>
                    </el-col>
                </el-row>
                <div>
                    <el-form status-icon inline label-width="110px">
                        <el-row>
                            <el-form-item label="商务谈判意见：" style="margin-bottom: 0;color: #606266">
                                {{remarks || '无'}}
                            </el-form-item>
                        </el-row>
                        <el-row>
                            <el-form-item label="相关附件：" style="margin-bottom: 0;">
                                <!-- @finishUpload="checkForm()" -->
                                <page-upload
                                    
                                    :files="bussinessAttachment"
                                    :editFlag="false"
                                    :attachmentType="39">
                                </page-upload>
                                <!-- <a href="javascript:;" v-for="item in bussinessAttachment" :key="item.attachName"
                                   @click="$root.downloadFile(item)"
                                   style="color:#0091FF; padding: 0 15px 0 0">{{ item.attachName }}</a> -->
                            </el-form-item>
                        </el-row>
                    </el-form>
                    <el-form :model="wFlowFormInfo" :disabled="true"  status-icon inline label-width="110px">
                        <!-- 报价方式（1：总价包干，2：单价包干） -->
                        <el-form-item label="报价方式：" style="margin-bottom: 0px;width: 43.5%;">
                                <el-radio-group v-model="wFlowFormInfo.quotationMethod" >
                                    <el-radio :label="1">总价包干</el-radio>
                                    <el-radio :label="0">单价包干</el-radio>
                                </el-radio-group>
                        </el-form-item>
                        <!-- 税率（1：固定税率，2：非固定税率） -->
                        <el-form-item label="税率：" style="margin-bottom: 0px;">
                                <el-radio-group v-model="wFlowFormInfo.taxRatioMethod">
                                    <el-radio :label="1">固定税率</el-radio>
                                    <el-radio :label="2">非固定税率</el-radio>
                                </el-radio-group>
                        </el-form-item>
                        <el-row v-if="extWFlowForm.estimatedAmount >= 100000">
                            <el-col :span="24">
                                <el-form-item label="建筑面积：" style="margin-bottom: 0px;width: 43.5%;">
                                    <el-input v-model.trim="wFlowFormInfo.constructArea" style="margin-bottom: 0px;"
                                              size="mini" class="width100">
                                        <span slot="suffix">m²</span>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="单方：" style="margin-bottom: 0px;">
                                    <el-input v-model.trim="wFlowFormInfo.constructAreaPerM2"
                                              style="margin-bottom: 0px;"
                                              size="mini" class="width100">
                                        <span slot="suffix">元/m²</span>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="服务面积/机房面积/改造面积：" style="margin-bottom: 0px;width: 43.5%;">
                                    <el-input v-model.trim="wFlowFormInfo.serviceRenovationArea"
                                              style="margin-bottom: 0px;"
                                              size="mini" class="width100">
                                        <span slot="suffix">m²</span>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="单方：" style="margin-bottom: 0px;">
                                    <el-input v-model.trim="wFlowFormInfo.serviceRenovationAreaPerM2"
                                              style="margin-bottom: 0px;"
                                              size="mini" class="width100">
                                        <span slot="suffix">元/m²</span>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="租赁面积：" style="margin-bottom: 0px;width: 43.5%;">
                                    <el-input v-model.trim="wFlowFormInfo.rentalArea" style="margin-bottom: 0px;"
                                              size="mini" class="width100">
                                        <span slot="suffix">m²</span>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="单方：" style="margin-bottom: 0px;">
                                    <el-input v-model.trim="wFlowFormInfo.rentalAreaPerM2" style="margin-bottom: 0px;"
                                              size="mini" class="width100">
                                        <span slot="suffix">元/m²</span>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                    <el-form status-icon inline label-width="110px">
                        <el-form-item style="margin-bottom: 0;">
                            <el-form-item label="不含税合价：">
                                <el-input size="mini" style="width: 180px" v-model="sumNoTax" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="含税合价：">
                                <el-input size="mini" style="width: 180px" v-model="sumTax" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="税金：">
                                <el-input size="mini" style="width: 180px" v-model="tax" disabled></el-input>
                            </el-form-item>
                            <el-button size="mini" style="margin-left: 15px" :disabled="false" @click="sumPrice">查看合价</el-button>
                        </el-form-item>
                    </el-form>
                    <div style="display: inline-flex;width: 100%;padding-top: 5px">
                        <span style="width: 95%"></span>
                        <el-upload
                            :action="tempUrl"
                            :show-file-list="false"
                            :multiple="false"
                            :http-request="beforeFileInput"
                            :on-error="uploadErr"
                            :on-success="uploadSuc">
                            <span class="text-button f14" style="float: right;width: 60px;cursor: pointer;"><i class="iconfont icondaoru2"></i> 导入</span>
                        </el-upload>
                        <div>
                            <span class="text-button f14" style="float: right;margin-left: 20px;width: 68px;cursor: pointer;" @click.stop="fileOutput"><i class="iconfont icondaochu"></i> 导出</span>
                        </div>
                    </div>
                    <div style="margin-bottom: 20px;margin-left: 20px;" v-show="1 == wflowFormListFlag">
                        <inventory_BigData ref="inventory_page" :readonly="false" :segments="wFlowFormInfo.segmentsNumber" :code="extWFlowForm.categoryCode" :parentCode="extWFlowForm.parentCategoryCode" page="businessNegotiation" :taxRatioFlag="wFlowFormInfo.taxRatioMethod" :quotationFlag="wFlowFormInfo.quotationMethod"></inventory_BigData>
                    </div>
                    <div style="margin-bottom: 20px;margin-left: 20px;" v-show="1 != wflowFormListFlag">
                        <inventory ref="inventory" :readonly="false" :segments="wFlowFormInfo.segmentsNumber" :code="extWFlowForm.categoryCode" :parentCode="extWFlowForm.parentCategoryCode" page="businessNegotiation" :taxRatioFlag="wFlowFormInfo.taxRatioMethod" :quotationFlag="wFlowFormInfo.quotationMethod"></inventory>
                    </div>
                    <div style="margin-bottom: 20px;margin-left: 20px;" v-if="false">
                        <inventory v-if="wFlowFormInfo.quotationMethod == 1 && extWFlowForm.estimatedAmount >= 100000" style="margin-top: 10px;" :validateFlag="false" ref="inventory1" :readonly="false" :code="extWFlowForm.categoryCode" :parentCode="extWFlowForm.parentCategoryCode" page="businessNegotiation" :taxRatioFlag="wFlowFormInfo.taxRatioMethod" :quotationFlag="wFlowFormInfo.quotationMethod"></inventory>
                    </div>
                </div>
            </section>
            <section class="small-container">
                <div class="line-display">
                    <h3 class="iconfont iconxiala">附件上传</h3>
                </div>
                <el-row class="colorLine">
                    <el-col :span="10">
                        <div style="height: 1px;background: #91002c;"></div>
                    </el-col>
                    <el-col :span="14">
                        <div style="height: 1px;background: #003570;"></div>
                    </el-col>
                </el-row>
                <el-form status-icon ref="attachementVO" inline :model="attachementVO" :rules="attachementVORules" :label-width="formLabelWidth" style="margin:20px 0;">
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="回传附件：" prop="bussinessList" class="noMarginBottom attachmentForm">
                                <page-upload
                                        @finishUpload="checkForm()"
                                        :files="attachementVO.bussinessList"
                                        :editFlag="true"
                                        :attachmentType="39">
                                </page-upload>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </section>
        </div>
    </div>
</template>

<script type="text/babel">
import MyHeader from '../common/Header.vue'
import MyFooter from '../common/Footer.vue'
export default {
    name: "businessNegotiation",
    components: {
        MyHeader, MyFooter
    },
    data() {
        return {
            sumTax:'',
            sumNoTax:'',
            tax:'',
            tableHeaderStyle: Object.assign({}, this.$root.tableHeaderStyle, {'text-align': 'left',}),
            tableCellStyle: Object.assign({}, this.$root.tableCellStyle, {'text-align': 'left',}),
            formLabelWidth: '200px',

            extWFlowForm: {},
            wFlowFormInfo: {
                quotationMethod: 1, //报价方式
                taxRatioMethod: 1, //税率
            },
            bussinessAttachment:[],
            supplierId: window.sessionStorage.getItem('loginId'),

            attachementVO: {
              bussinessList: [],
            },
            attachementVORules: {
                bussinessList: [{
                      required: true,
                      message: '请选择附件',
                      trigger: 'blur'
                  }
              ],
            },
            wflowFormListFlag: null,
            tempUrl:this.$root.baseUrl + '/v1/outerformflowHS/modelExcelmportFileWithID',
            remarks:'',
        }
    },
    created() {
        this.dealId = this.$route.params.dealId;
        this.getDetail();
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        toDownload(url) {
            window.location.href = url;
        },
        sumPrice(){
            try {
                if(this.wflowFormListFlag){
                    this.$root.getFunc('/v1/outerformflowHS/getFlowFromListTotal?dealId='+ this.dealId +"&extranet=2",(res)=>{
                        this.sumTax = this.$root.rounding(res.data.data.sumTax);
                        this.sumNoTax = this.$root.rounding(res.data.data.sumNoTax);
                        this.tax = this.$root.rounding(res.data.data.tax);
                        if (this.wFlowFormInfo.constructArea) {
                            this.wFlowFormInfo.constructAreaPerM2 = (parseFloat(this.sumTax) / parseFloat(this.wFlowFormInfo.constructArea)).toFixed(2)
                        } else {
                            this.wFlowFormInfo.constructAreaPerM2 = ''
                        }
                        if (this.wFlowFormInfo.serviceRenovationArea) {
                            this.wFlowFormInfo.serviceRenovationAreaPerM2 = (parseFloat(this.sumTax) / parseFloat(this.wFlowFormInfo.serviceRenovationArea)).toFixed(2)
                        } else {
                            this.wFlowFormInfo.serviceRenovationAreaPerM2 = ''
                        }
                        if (this.wFlowFormInfo.rentalArea) {
                            this.wFlowFormInfo.rentalAreaPerM2 = (parseFloat(this.sumTax) / parseFloat(this.wFlowFormInfo.rentalArea)).toFixed(2)
                        } else {
                            this.wFlowFormInfo.rentalAreaPerM2 = ''
                        }
                    })
                    return
                }
                let listData = this.$refs['inventory'].getData();
                let sum1 = 0;
                let sum2 = 0;
                listData.forEach(item => {
                    if (item.quotationType != 2) {
                        if (!item.unitAmountWithTax) {
                            return
                        }
                        let tempDayAmount = 1;
                        if (item.dayAmount) {
                            tempDayAmount = parseFloat(item.dayAmount);
                        }
                        let tempServiceTime = 1;
                        if (item.serviceTime) {
                            tempServiceTime = parseFloat(item.serviceTime);
                        }
                        let amountWithTax = parseFloat(item.unitAmountWithTax) * parseFloat(item.quantities) * parseFloat(tempDayAmount) * parseFloat(tempServiceTime)
                        sum1 += parseFloat(amountWithTax)
                        sum2 += parseFloat((parseFloat(amountWithTax) / (1 + parseFloat(item.taxRatio) / 100)))
                    }
                })
                this.sumTax = Number.isNaN(sum1)?'':sum1.toFixed(2);
                this.sumNoTax = Number.isNaN(sum2)?'':sum2.toFixed(2);
                this.tax = Number.isNaN(sum1 - sum2)?'':(sum1 - sum2).toFixed(2);
                if (this.wFlowFormInfo.constructArea) {
                    this.wFlowFormInfo.constructAreaPerM2 = (parseFloat(this.sumTax) / parseFloat(this.wFlowFormInfo.constructArea)).toFixed(2)
                } else {
                    this.wFlowFormInfo.constructAreaPerM2 = ''
                }
                if (this.wFlowFormInfo.serviceRenovationArea) {
                    this.wFlowFormInfo.serviceRenovationAreaPerM2 = (parseFloat(this.sumTax) / parseFloat(this.wFlowFormInfo.constructArea)).toFixed(2)
                } else {
                    this.wFlowFormInfo.serviceRenovationAreaPerM2 = ''
                }
                if (this.wFlowFormInfo.rentalArea) {
                    this.wFlowFormInfo.rentalAreaPerM2 = (parseFloat(this.sumTax) / parseFloat(this.wFlowFormInfo.constructArea)).toFixed(2)
                } else {
                    this.wFlowFormInfo.rentalAreaPerM2 = ''
                }
            } catch (e) {
                this.sumTax = '';
                this.sumNoTax = '';
                this.tax = '';
                console.log(e.toString())
            }
        },
        uploadSuc(res){
            if (res.code === '1'){
                let that = this;
                this.$alert(res.msg,{
                    type:'success',
                    callback:()=>{
                        that.getDetail()
                    }});
            }
            else
                this.$alert('文件导入失败！',{type:'error'})
        },
        uploadErr(){
            this.$alert('导入失败！')
        },
        // beforeFileInput(param){
        //     this.save(0, (tn)=>{
        //         if (tn)
        //             this.fileInput(param,()=>{
        //                 this.getDetail()
        //             })
        //     },false);
        // },
        fileInput(param,fn){
            let that = this;
            let formData = new FormData()
            formData.append('dealId',this.dealId)
            formData.append('taxRatioMethod',this.wFlowFormInfo.taxRatioMethod)
            formData.append('type','')
            formData.append('file',param.file)
            formData.append('excelType','6')
            this.$root.postHttp('/v1/outerformflowHS/modelExcelmportFileWithID',formData, function (res) {
                if (res.data.code === '1'){
                    that.$alert(res.data.msg,{
                        type:'success',
                        callback:()=>{
                            fn()
                        }
                    })
                }
            });
        },
         beforeFileInput(param){
            let that = this
            this.fileInput(param, () => {
                that.getDetail()
            })
            // this.save(0, (tn)=>{
            //     if (tn)
            //         this.fileInput(param,()=>{
            //             this.getDetail()
            //         })
            // },false);
        },
        fileOutput(){
            let id = this.dealId;
            let url = this.$root.baseUrl + '/v1/outerformflowHS/public/exportBidList?token=' + (window.sessionStorage.getItem('token') || '') + '&dealId=' + id + '&parentCodeType=' + this.extWFlowForm.parentCategoryCode + '&codeType=' + this.extWFlowForm.categoryCode;
            window.location.href = url;
        },
        save(saveFlag, fn,showTips=true){
            let that = this;

            let listRef = this.$refs['inventory'];
            let listRef1 = this.$refs['inventory1'];

            let formParams = {
                dealId: this.dealId,
                bussinessFlag: saveFlag,
                wflowFormId: this.wflowaFormId,
                supplierId: this.supplierId,
                bussinessList: this.attachementVO.bussinessList,
                wflowFormListFlag:this.wflowFormListFlag
            };
            // formParams = Object.assign({}, formParams, listRef.getData());
            if(listRef){
                formParams.wflowFormListList = listRef.getData();
            }
            if(listRef1){
                formParams.wflowFormListList2 = listRef1.getData();
            }

            this.$root.postHttp('/v1/outerformflowHS/bussinessCommit',formParams,function(res){
                if (showTips)
                that.$alert('保存成功', '提示', {
                    confirmButtonText: '确定',
                    type: 'success',
                    callback: action => {

                    }
                });
                fn(true);
            },function(){
                fn(false);
            })
        },
        saveToDraft(){
            this.save(0, ()=>{
            });
        },
        submit(){
            let that = this;
            this.checkForm().then((res)=>{
                if(Array.isArray(res)){
                    this.save(1, ()=>{
                        that.$router.go(-1);
                    });
                }else {
                    this.$alert(res,{
                        type: 'warning'
                    });
                }
            }).catch(e=>{
                console.log(e);
            });
        },
        checkForm(){
            let checkPromise = [];

            let listRef = this.$refs['inventory'];
            if(!this.wflowFormListFlag && listRef){
                checkPromise.push(listRef.validate());
            }
            checkPromise.push(this.submitFormPromise('attachementVO'));

            return Promise.all(checkPromise).then(data=>{
                return data;
            })
            .catch(e => {
                console.log(e);
                return e;
                // reject(e);
            });
        },
        submitFormFnc(formName){
            let that = this;
            var f = function (){
                const p = new Promise((resolve, reject) => {
                    let form = that.$refs[formName];
                    if(Array.isArray(that.$refs[formName])){
                        form = that.$refs[formName][0]
                    }
                    form.validate((valid) => {
                        if(valid){
                            resolve(true);
                        } else {
                            reject('请完成必填信息的填写！');
                        }
                    });
                });
                return p;
            }
            return f;
        },
        submitFormPromise(formName){
            return this.submitFormFnc(formName)();
        },
        getDetail() {
            let that = this;
            this.$root.postHttp('/v1/outerformflowHS/getBusiness', {
              dealId: this.$route.params.dealId
            }, (res) => {
                that.bussinessAttachment = res.data.data.bussinessAttachment || [];
                that.wFlowFormInfo = res.data.data.wflowFormInfo;
                that.extWFlowForm = res.data.data.extWFlowForm;
                that.attachementVO.bussinessList = res.data.data.bussinessList || [];
                that.wflowFormListFlag = res.data.data.wflowFormListFlag;
                if(that.extWFlowForm.ssuppliersCategory!=null){
                    that.extWFlowForm.categoryCode = that.extWFlowForm.ssuppliersCategory.categoryCode;
                    that.extWFlowForm.parentCategoryCode = that.extWFlowForm.ssuppliersCategory.parentCategoryCode;
                }else{
                    that.extWFlowForm.categoryCode = '';
                    that.extWFlowForm.parentCategoryCode = '';
                }
                that.remarks = res.data.data.remarks;

                that.$nextTick(() => {
                    let listRef = that.$refs['inventory'];
                    let listRef_page = that.$refs['inventory_page'];
                    let listRef1 = that.$refs['inventory1'];
                    if (listRef_page && that.wflowFormListFlag == 1) {
                        listRef_page.setData(res.data.data.wflowFormListPage, {...res.data.data.wflowFormInfo, ...res.data.data.extWFlowForm.ssuppliersCategory,...{dealId:this.dealId}});
                    }
                    if (listRef) {
                        listRef.setData(res.data.data.wflowFormListList, {...res.data.data.wflowFormInfo, ...res.data.data.extWFlowForm.ssuppliersCategory});
                    }
                    if (listRef1) {
                        listRef1.setData(res.data.data.wflowFormListList2, {...res.data.data.wflowFormInfo, ...res.data.data.extWFlowForm.ssuppliersCategory});
                    }
                })
           });
        },
    }
}
</script>

<style scoped lang="scss">
@import '../../assets/_var.scss';
@import "../../assets/iconfont/iconfont.css";
.main-container {
    width: 1100px;
    text-align: left;
}

.container /deep/ {
    margin-top: 60px;
    margin-bottom: 150px;
    padding-bottom: 15px;
    background-color: #ffffff;

    .el-form-item__error{
        width: 300px;
    }

    .text-button.el-button {
        font-size: 16px;
        text-align: left;
        color: #333333;
        line-height: 21px;
        background: white;
        border: none;
    }
    .f14 {
        font-size: 14px !important;
    }
    & .unit {
        width: 100px;
        margin-right: 5px;
    }
    & .tip {
        margin-left: 10px;
        color: $--primary-color;
        font-size: 12px;
    }
    & .add {
        float: right;
        font-size: 14px;
        cursor: pointer;
        & img {
            vertical-align: middle;
            width: 70px;
            height: 26px;
        }
    }
    & .dele {
        position: absolute;
        top: 0px;
        right: 10px;
    }
    & .dele img {
        transform: scale(1);
        transition: .5s;
        width: 34px;
        height: 34px;
    }
    .dele:hover img {
        transform: scale(1.1);
    }
    & .remarks {
        width: 95%;
    }
    & .naturalForm {
        padding: 20px 10px 5px;
        padding-left: 0px;
        padding-right: 26px;
        border: 1px solid #dcdfe6;
        border-radius: 3px;
        margin-bottom: 20px;
    }
    & h4 {
        padding: 0 30px;
        text-align: left;
        line-height: 50px;
        color: $--text-color-light;
        background: $--secondary-fill-color;
        overflow: hidden;
        position: relative;
    }
    & h4 {
        text-indent: 10px;
        line-height: 35px;
        background: $--primary-fill-color;
    }
    & h5 {
        padding: 0 30px;
    }
    .el-input__inner {
        border: none;
        border-bottom: 1px solid #C4C4C4;
        border-radius: 0px;
    }
    .el-input.is-disabled .el-input__inner, .el-textarea.is-disabled .el-textarea__inner {
        background-color: white;
        cursor: default;
    }
    .maxWidthForm {
        width: 100%;
        .el-form-item__content {
            width: calc(100% - 260px);
        }
    }

    .maxWidthForm-2 {
      width: 100%;
        .el-form-item__content {
            width: calc(100% - 100px);
        }
    }
    .el-form-item__error {
        width: 300px;
        padding: 0;
    }

    .el-form-item__label, .el-form-item__content{
        line-height: 33px;
    }

}

.box-card {
    margin-bottom: 15px;
}

.minWidth {
    width: 250px;
}

h3 {
    // background-color: #ececec;
    padding: 5px 20px;
    margin: 0;
    // margin-top: 10px;
    position: relative;
    cursor: pointer;
}

.iconxiala::before {
    position: absolute;
    left: -5px;
    font-size: 20px;
}

.colorLine {
    margin-bottom: 20px;
    padding-left: 20px;
}

h2 {
    font-size: 13px;
    margin-left: 20px;
}

.noMarginBottom {
    // margin-bottom: 0!important;
    margin-bottom: 10px !important;
    .tipWrap {
        position: relative;
        min-width: 250px;
        .tips {
            position: absolute;
            top: 16px;
            left: 100px;
            padding-left: 20px;
            font-size: 12px;
            color: $--text-color-light;
            background: url('../../assets/images/register/tip.png') no-repeat left center;
        }
    }
}

.cf:before,
.cf:after {
    content: "";
    display: table;
}

.cf:after {
    clear: both;
}

.attachmentDiv /deep/{
  text-align: left;
  .file-list {
    margin-top: 10px;
  }
  .file-button{
      margin-top:-5px;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/bid/businessNegotiation.vue